import { render, staticRenderFns } from "./HeaderOnlyLogo.vue?vue&type=template&id=aa04d37c&scoped=true"
var script = {}
import style0 from "./HeaderOnlyLogo.vue?vue&type=style&index=0&id=aa04d37c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa04d37c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa04d37c')) {
      api.createRecord('aa04d37c', component.options)
    } else {
      api.reload('aa04d37c', component.options)
    }
    module.hot.accept("./HeaderOnlyLogo.vue?vue&type=template&id=aa04d37c&scoped=true", function () {
      api.rerender('aa04d37c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/HeaderOnlyLogo.vue"
export default component.exports